import React, { useEffect, useMemo, useState, useRef } from "react";
import { useGlobalContext } from "../Config";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";
import { TabView, TabPanel } from "primereact/tabview";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { ProgressSpinner } from "primereact/progressspinner";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { FileUpload } from "primereact/fileupload";
import { AutoComplete } from "primereact/autocomplete";
import { useLocation } from "react-router-dom";
import { formatDateCL } from "../utilities/DateUtil";
import { Galleria } from "primereact/galleria";
import { useNavigate } from "react-router-dom";

const Inventario = () => {
  const { baseUrl, urlContactos } = useGlobalContext();
  const location = useLocation();
  const [activeIndex, setActiveIndex] = useState(0);
  const categoriaActual = useMemo(
    () => (activeIndex === 0 ? "MEDIDOR" : "REMARCADOR"),
    [activeIndex],
  );

  const [isLoading, setIsLoading] = useState(false);

  const [medidores, setMedidores] = useState([]);
  const [remarcadores, setRemarcadores] = useState([]);

  const [proveedores, setProveedores] = useState([]);
  const proveedoresOptions = useMemo(
    () =>
      proveedores.map((p) => ({
        label: `${p.razonSocial || "Proveedor"} (${p.rut || "S/R"})`,
        value: p.id,
      })),
    [proveedores],
  );

  const navigate = useNavigate();
  const [dialogVisible, setDialogVisible] = useState(false);
  const [modoDialog, setModoDialog] = useState("crear");
  const [form, setForm] = useState({
    id: null,
    codigo: "",
    numeroCliente: "",
    qrCode: null,
    idEmpresa: null,
    idProveedor: null,
    idTipo: null,
    idUnidadMedida: null,
    marca: "",
    caracteristica: "",
    contrato: "",
    ruta: "",
    ubicacion: "",
    ubicacionDetalle: "",
    fechaInstalacion: null,
    lecturaInicial: null,
    activo: true,
  });

  const empresasOptions = [
    { label: "ALTAMIRA", value: 1 },
    { label: "LA SIEMBRA", value: 2 },
  ];

  const [relDialogVisible, setRelDialogVisible] = useState(false);
  const [relMedidorBase, setRelMedidorBase] = useState(null);
  const [relRemarcadorId, setRelRemarcadorId] = useState(null);
  const [detalleMedidorVisible, setDetalleMedidorVisible] = useState(false);
  const [medidorSeleccionado, setMedidorSeleccionado] = useState(null);
  const [remarcadoresAsociados, setRemarcadoresAsociados] = useState([]);
  const [cantidadRemarcadoresAsociados, setCantidadRemarcadoresAsociados] =
    useState(0);
  const [nuevoRemarcadorId, setNuevoRemarcadorId] = useState(null);
  const [tipos, setTipos] = useState([]);
  const [unidadesMedida, setUnidadesMedida] = useState([]);
  const [configMedidoresMap, setConfigMedidoresMap] = useState(new Map());
  const [configRemarcadoresMap, setConfigRemarcadoresMap] = useState(new Map());
  const [ubicacionSug, setUbicacionSug] = useState([]);
  const [fotoDialogVisible, setFotoDialogVisible] = useState(false);
  const [itemFoto, setItemFoto] = useState(null);
  const [fotoFile, setFotoFile] = useState(null);
  const [fotoPreview, setFotoPreview] = useState(null);
  const [fotoExistente, setFotoExistente] = useState(null);
  const fotoUploadRef = useRef(null);
  const [fotoUploadKey, setFotoUploadKey] = useState(0);
  const [pdfMedidoresVisible, setPdfMedidoresVisible] = useState(false);
  const [pdfFiles, setPdfFiles] = useState([]);
  const [pdfResultados, setPdfResultados] = useState([]);
  const [pdfMensaje, setPdfMensaje] = useState(null);

  // --- INCIDENCIAS ---
  const [incDialogVisible, setIncDialogVisible] = useState(false);
  const [incItem, setIncItem] = useState(null);
  const [incObservacion, setIncObservacion] = useState("");
  const [incHistorial, setIncHistorial] = useState([]);
  const tienePendiente = (incHistorial || []).some((x) => !x.fechaResolucion);

  // --- FILTROS ---
  const [fEmpresaId, setFEmpresaId] = useState(null);
  const [fProveedorId, setFProveedorId] = useState(null);
  const [fQrExacto, setFQrExacto] = useState("");
  const [fUbicacion, setFUbicacion] = useState("");
  const [fActivo, setFActivo] = useState("ACTIVOS");
  const [fCodigo, setFCodigo] = useState("");
  const [fNumeroCliente, setFNumeroCliente] = useState("");
  const [fRuta, setFRuta] = useState("");
  const [fTipoId, setFTipoId] = useState(null);

  const [newIds, setNewIds] = useState(new Set());

  const [fotos, setFotos] = useState([]);
  const [activeFotoIndex, setActiveFotoIndex] = useState(0);

  const activosOptions = [
    { label: "Activos", value: "ACTIVOS" },
    { label: "Inactivos", value: "INACTIVOS" },
    { label: "Todos", value: "TODOS" },
  ];

  const query = useMemo(
    () => new URLSearchParams(location.search),
    [location.search],
  );

  const empresaIdFromQuery = query.get("empresaId")
    ? Number(query.get("empresaId"))
    : null;

  const medidorIdFromQuery = query.get("medidorId")
    ? Number(query.get("medidorId"))
    : null;

  const [empresaId, setEmpresaId] = useState(empresaIdFromQuery);
  const [medidorId, setMedidorId] = useState(medidorIdFromQuery);

  const politicaLabel = (politica) => {
    switch (politica) {
      case "MISMO_DIA":
        return "Mismo día";
      case "ANTERIOR_HABIL":
        return "Hábil anterior";
      case "SIGUIENTE_HABIL":
        return "Hábil siguiente";
      default:
        return politica || "-";
    }
  };

  const rangoLabel = (diaDesde, diaHasta) => {
    if (!diaDesde || !diaHasta) return "-";
    return `${diaDesde} → ${diaHasta}`;
  };

  const origenLabel = (origen) => {
    if (origen === "MEDIDOR") return "Propia";
    if (origen === "EMPRESA") return "Empresa";
    return "-";
  };

  const isActivo = (x) => x?.activo === true || x?.activo === 1;

  const normTxt = (s) =>
    String(s ?? "")
      .trim()
      .toUpperCase()
      .replace(/\s+/g, " ");

  const matchesActivo = (row) => {
    const act = isActivo(row);
    if (fActivo === "ACTIVOS") return act;
    if (fActivo === "INACTIVOS") return !act;
    return true; // TODOS
  };

  const applyFilters = (rows) => {
    const qr = normTxt(fQrExacto);
    const ubi = normTxt(fUbicacion);
    const codigo = normTxt(fCodigo);
    const numeroCliente = normTxt(fNumeroCliente);
    const ruta = normTxt(fRuta);

    return (rows || []).filter((r) => {
      if (fEmpresaId && Number(r?.empresa?.id) !== Number(fEmpresaId))
        return false;
      if (fProveedorId && Number(r?.proveedor?.id) !== Number(fProveedorId))
        return false;

      if (codigo && !normTxt(r?.codigo).includes(codigo)) return false;

      if (numeroCliente && !normTxt(r?.numeroCliente).includes(numeroCliente)) {
        return false;
      }

      if (ruta && !normTxt(r?.ruta).includes(ruta)) return false;

      if (fTipoId && Number(r?.tipo?.id) !== Number(fTipoId)) return false;

      // QR exacto (si se ingresa)
      if (qr) {
        const rowQr = normTxt(r?.qrCode);
        if (rowQr !== qr) return false;
      }

      // Ubicacion contains
      if (ubi) {
        const rowUbi = normTxt(
          [r?.ubicacion, r?.ubicacionDetalle].filter(Boolean).join(" "),
        );
        if (!rowUbi.includes(ubi)) return false;
      }

      if (!matchesActivo(r)) return false;

      return true;
    });
  };

  const resetFotoUploader = () => {
    try {
      fotoUploadRef.current?.clear?.();
    } catch {}
    setFotoFile(null);
    setFotoPreview(null);

    setFotoUploadKey((k) => k + 1);
  };

  const medidoresFiltrados = useMemo(
    () => applyFilters(medidores),
    [
      medidores,
      fEmpresaId,
      fProveedorId,
      fQrExacto,
      fUbicacion,
      fActivo,
      fCodigo,
      fNumeroCliente,
      fRuta,
      fTipoId,
    ],
  );

  const remarcadoresFiltrados = useMemo(
    () => applyFilters(remarcadores),
    [
      remarcadores,
      fEmpresaId,
      fProveedorId,
      fQrExacto,
      fUbicacion,
      fActivo,
      fCodigo,
      fNumeroCliente,
      fRuta,
      fTipoId,
    ],
  );

  const [remarcadoresRelacionados, setRemarcadoresRelacionados] = useState(
    new Set(),
  );

  const [remarcadorToMedidor, setRemarcadorToMedidor] = useState(new Map());

  const isRemarcadorRelacionado = (idRemarcador) =>
    remarcadoresRelacionados.has(Number(idRemarcador));

  const tiposOptions = useMemo(
    () =>
      tipos.map((t) => ({
        label: t.descripcion,
        value: t.id,
      })),
    [tipos],
  );

  const unidadesOptions = useMemo(
    () =>
      unidadesMedida.map((u) => ({
        label: u.descripcion,
        value: u.id,
      })),
    [unidadesMedida],
  );

  const getTipoId = (item) => item?.tipo?.id ?? null;

  const remarcadoresOptionsAsignar = useMemo(() => {
    const tipoBaseId = getTipoId(medidorSeleccionado);
    if (!tipoBaseId) return [];

    return remarcadores
      .filter(isActivo)
      .filter((r) => getTipoId(r) === tipoBaseId)
      .filter((r) => !isRemarcadorRelacionado(r.id))
      .map((r) => ({
        label: `Remarcador QR: ${r.qrCode ?? "-"}`,
        value: r.id,
      }));
  }, [remarcadores, medidorSeleccionado]);

  const remarcadoresOptionsRelacion = useMemo(() => {
    const tipoBaseId = getTipoId(relMedidorBase);
    if (!tipoBaseId) return []; // si no hay tipo, no mostramos nada

    return remarcadores
      .filter(isActivo)
      .filter((r) => getTipoId(r) === tipoBaseId)
      .filter((r) => !isRemarcadorRelacionado(r.id))
      .map((r) => ({
        label: `Remarcador QR: ${r.qrCode ?? "-"}`,
        value: r.id,
      }));
  }, [remarcadores, relMedidorBase]);

  const medidoresOptionsRelacion = useMemo(() => {
    const remBase = remarcadores.find((r) => r?.id === relRemarcadorId);
    const tipoBaseId = getTipoId(remBase);
    if (!tipoBaseId) return [];

    return medidores
      .filter(isActivo)
      .filter((m) => getTipoId(m) === tipoBaseId)
      .map((m) => ({
        label: `Medidor Código: ${m.codigo ?? "-"}`,
        value: m.id,
      }));
  }, [medidores, remarcadores, relRemarcadorId]);

  const tituloBotonAgregar =
    categoriaActual === "MEDIDOR" ? "Agregar Medidor" : "Agregar Remarcador";

  const endpointBuscarPorCategoria = (categoria) =>
    `${baseUrl}medidor/buscar/categoria?categoria=${encodeURIComponent(
      categoria,
    )}`;

  const resetPdfFiles = () => {
    const el = document.getElementById("pdf_medidores_input");
    if (el) el.value = "";
    setPdfFiles([]);
  };

  const onPickPdfMedidores = (e) => {
    const list = Array.from(e.target.files || []);
    const onlyPdf = list.filter((f) => {
      const name = (f?.name || "").toLowerCase();
      return name.endsWith(".pdf") || f?.type === "application/pdf";
    });

    if (!onlyPdf.length) {
      setPdfMensaje({
        severity: "warn",
        text: "Seleccione uno o más archivos PDF.",
      });
      resetPdfFiles();
      return;
    }

    setPdfFiles(onlyPdf);
    setPdfMensaje(null);
  };

  const fileToBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(String(reader.result || ""));
      reader.onerror = () =>
        reject(reader.error || new Error("Error leyendo archivo"));
      reader.readAsDataURL(file);
    });

  const getByPath = (obj, path, def = "") => {
    if (!obj) return def;
    const parts = String(path).split(".");
    let cur = obj;
    for (const p of parts) {
      if (cur == null) return def;
      cur = cur[p];
    }
    return cur ?? def;
  };

  const leerPdfMedidores = async () => {
    setPdfMensaje(null);

    if (!fProveedorId) {
      setPdfMensaje({
        severity: "warn",
        text: "Debes seleccionar un proveedor en los filtros.",
      });
      return;
    }

    if (!pdfFiles?.length) {
      setPdfMensaje({
        severity: "warn",
        text: "Debes seleccionar al menos un PDF.",
      });
      return;
    }

    setIsLoading(true);
    try {
      const archivos = [];
      for (const f of pdfFiles) {
        const b64 = await fileToBase64(f);
        archivos.push({ nombre: f.name, base64: b64 });
      }

      const data = await fetchJson(`${baseUrl}boletaPdf/extract`, {
        method: "POST",
        body: JSON.stringify({
          proveedorId: fProveedorId,
          archivos,
        }),
      });

      const resultados = Array.isArray(data?.resultados) ? data.resultados : [];
      const normalized = resultados.map((r, idx) => ({
        ...r,
        _rowKey: `${r?.pdfUploadId ?? "noid"}_${idx}`,
      }));

      const empIds = Array.from(
        new Set(normalized.map((r) => r?.empresaId).filter((v) => v != null)),
      );

      if (empIds.length === 1) {
        setFEmpresaId(empIds[0]);
      }

      setPdfResultados(normalized);
      setPdfMensaje({
        severity: "success",
        text: `Lectura OK: ${normalized.length} archivo(s).`,
      });

      resetPdfFiles();
    } catch (e) {
      setPdfResultados([]);
      setPdfMensaje({
        severity: "error",
        text: "Error leyendo PDFs: " + (e?.message || e),
      });
      resetPdfFiles();
    } finally {
      setIsLoading(false);
    }
  };

  const confirmarPdfMedidores = () => {
    if (!fProveedorId) return alert("Debes seleccionar proveedor.");
    if (!fEmpresaId) return alert("Debes seleccionar o resolver empresa.");
    if (!pdfResultados?.length)
      return alert("No hay resultados para confirmar.");

    confirmDialog({
      header: "Confirmar carga de medidores",
      icon: "pi pi-check",
      message: `¿Deseas cargar medidores desde ${pdfResultados.length} PDF(s)?`,
      acceptLabel: "Sí",
      rejectLabel: "No",
      accept: async () => {
        setIsLoading(true);
        try {
          const resp = await fetchJson(
            `${baseUrl}boletaPdf/confirm-medidores`,
            {
              method: "POST",
              body: JSON.stringify({
                empresaId: fEmpresaId,
                proveedorId: fProveedorId,
                items: pdfResultados.map((r) => ({
                  pdfUploadId: r?.pdfUploadId ?? null,
                  nombre: r?.nombre ?? "",
                  data: r?.data ?? {},
                })),
              }),
            },
          );

          const created = Array.isArray(resp?.medidoresCreados)
            ? resp.medidoresCreados
            : [];

          await cargarInventario();

          if (created.length > 0) {
            const ids = created
              .map((x) => Number(x?.medidorId))
              .filter((n) => Number.isFinite(n));

            setNewIds(new Set(ids));
            setActiveIndex(0);
            setFProveedorId(fProveedorId);
            setFEmpresaId(fEmpresaId);
          }

          setPdfResultados([]);
          setPdfMedidoresVisible(false);

          alert(
            created.length > 0
              ? `Carga OK. Se crearon ${created.length} medidor(es) nuevos.`
              : "Carga OK. No fue necesario crear medidores nuevos.",
          );
        } catch (e) {
          alert("Error cargando medidores: " + (e?.message || e));
        } finally {
          setIsLoading(false);
        }
      },
    });
  };

  const fetchJson = async (url, options = {}) => {
    const res = await fetch(url, {
      credentials: "include",
      redirect: "follow",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...(options.headers || {}),
      },
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok || data?.respuesta === false) {
      const msg = data?.mensaje || `Error HTTP ${res.status}`;
      throw new Error(msg);
    }
    return data;
  };

  const cargarIncidencias = async (idMedidor) => {
    if (!idMedidor) return [];
    try {
      const data = await fetchJson(
        `${baseUrl}medidor/incidencias?idMedidor=${encodeURIComponent(
          idMedidor,
        )}`,
        { method: "GET" },
      );
      const list = Array.isArray(data?.items) ? data.items : [];
      setIncHistorial(list);
      return list;
    } catch (e) {
      console.warn("No se pudieron cargar incidencias:", e?.message || e);
      setIncHistorial([]);
      return [];
    }
  };

  const abrirReportarIncidencia = async (row) => {
    setIncItem(row);
    setIncObservacion("");
    setIncDialogVisible(true);
    await cargarIncidencias(row?.id);
  };

  const reportarIncidencia = async () => {
    if (!incItem?.id) return alert("No hay item seleccionado.");
    const obs = String(incObservacion || "").trim();
    if (!obs) return alert("Debes ingresar una observación.");

    setIsLoading(true);
    try {
      await fetchJson(`${baseUrl}medidor/incidencias/reportar`, {
        method: "POST",
        body: JSON.stringify({
          idMedidor: incItem.id,
          observacion: obs,
        }),
      });

      alert("Incidencia reportada.");
      setIncObservacion("");
      await cargarIncidencias(incItem.id);
    } catch (e) {
      alert("Error reportando incidencia: " + (e?.message || e));
    } finally {
      setIsLoading(false);
    }
  };

  const resolverIncidencia = async (incidenciaId, idMedidorToRefresh) => {
    if (!incidenciaId) return;
    confirmDialog({
      message: "¿Marcar esta incidencia como resuelta?",
      header: "Confirmar",
      icon: "pi pi-exclamation-triangle",
      accept: async () => {
        setIsLoading(true);
        try {
          await fetchJson(
            `${baseUrl}medidor/incidencias/resolver?id=${encodeURIComponent(
              incidenciaId,
            )}`,
            { method: "PUT" },
          );
          await cargarIncidencias(idMedidorToRefresh);
        } catch (e) {
          alert("Error resolviendo: " + (e?.message || e));
        } finally {
          setIsLoading(false);
        }
      },
    });
  };

  const cargarProveedores = async () => {
    const data = await fetchJson(`${baseUrl}proveedor/buscar`, {
      method: "GET",
    });
    // según tu backend: viene { proveedores: [...] }
    setProveedores(Array.isArray(data.proveedores) ? data.proveedores : []);
  };

  const cargarTipos = async () => {
    const data = await fetchJson(`${baseUrl}tipo/buscar`, { method: "GET" });
    setTipos(Array.isArray(data.tipos) ? data.tipos : []);
  };

  const cargarUnidades = async () => {
    const data = await fetchJson(`${baseUrl}unidad-medida/buscar`, {
      method: "GET",
    });

    // tu controller devuelve "unidadesMedida"
    setUnidadesMedida(
      Array.isArray(data.unidadesMedida) ? data.unidadesMedida : [],
    );
  };

  const construirRelaciones = async (listaMedidores) => {
    try {
      const tasks = (listaMedidores || [])
        .filter((m) => m?.id)
        .map((m) =>
          fetchJson(
            `${baseUrl}medidor/remarcadores?idMedidor=${encodeURIComponent(
              m.id,
            )}`,
            { method: "GET" },
          )
            .then((data) => ({
              idMedidor: m.id,
              remarcadores: Array.isArray(data?.remarcadores)
                ? data.remarcadores
                : [],
            }))
            .catch(() => ({ idMedidor: m.id, remarcadores: [] })),
        );

      const results = await Promise.all(tasks);

      const setIds = new Set();
      const map = new Map();

      for (const r of results) {
        for (const rem of r.remarcadores) {
          if (rem?.id != null) {
            const rid = Number(rem.id);
            setIds.add(rid);
            map.set(rid, Number(r.idMedidor));
          }
        }
      }

      setRemarcadoresRelacionados(setIds);
      setRemarcadorToMedidor(map);
    } catch (e) {
      console.warn("No se pudieron construir relaciones:", e?.message || e);
      setRemarcadoresRelacionados(new Set());
      setRemarcadorToMedidor(new Map());
    }
  };

  const cargarInventario = async () => {
    setIsLoading(true);
    try {
      const results = await Promise.allSettled([
        fetchJson(endpointBuscarPorCategoria("MEDIDOR"), { method: "GET" }),
        fetchJson(endpointBuscarPorCategoria("REMARCADOR"), { method: "GET" }),
      ]);

      const dataMed =
        results[0].status === "fulfilled" ? results[0].value : null;
      const dataRem =
        results[1].status === "fulfilled" ? results[1].value : null;

      setMedidores(Array.isArray(dataMed?.medidores) ? dataMed.medidores : []);
      setRemarcadores(
        Array.isArray(dataRem?.medidores) ? dataRem.medidores : [],
      );

      await construirRelaciones(
        Array.isArray(dataMed?.medidores) ? dataMed.medidores : [],
      );
    } catch (e) {
      alert("Error cargando inventario: " + e.message);
    } finally {
      setIsLoading(false);
    }
  };

  const cargarConfiguracionMedidoresInventario = async (idEmpresa) => {
    if (!idEmpresa) return new Map();

    const data = await fetchJson(
      `${baseUrl}medidor/empresa/configuracion?idEmpresa=${encodeURIComponent(
        idEmpresa,
      )}`,
      { method: "GET" },
    );

    const rows = Array.isArray(data?.medidores) ? data.medidores : [];
    const map = new Map();

    rows.forEach((row) => {
      if (row?.id != null) {
        map.set(Number(row.id), row);
      }
    });

    return map;
  };

  const cargarConfiguracionRemarcadoresInventario = async (idEmpresa) => {
    if (!idEmpresa) return new Map();

    const data = await fetchJson(
      `${baseUrl}remarcador/empresa/configuracion?idEmpresa=${encodeURIComponent(
        idEmpresa,
      )}`,
      { method: "GET" },
    );

    const rows = Array.isArray(data?.remarcadores) ? data.remarcadores : [];
    const map = new Map();

    rows.forEach((row) => {
      if (row?.id != null) {
        map.set(Number(row.id), row);
      }
    });

    return map;
  };

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      try {
        await Promise.all([
          cargarProveedores(),
          cargarTipos(),
          cargarUnidades(),
          cargarInventario(),
        ]);
      } catch (e) {
        alert("Error inicial: " + e.message);
      } finally {
        setIsLoading(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    (async () => {
      try {
        if (!fEmpresaId) {
          setConfigMedidoresMap(new Map());
          setConfigRemarcadoresMap(new Map());
          return;
        }

        const [medMap, remMap] = await Promise.all([
          cargarConfiguracionMedidoresInventario(fEmpresaId),
          cargarConfiguracionRemarcadoresInventario(fEmpresaId),
        ]);

        setConfigMedidoresMap(medMap);
        setConfigRemarcadoresMap(remMap);
      } catch (e) {
        console.warn(
          "No se pudo cargar configuración de inventario:",
          e?.message || e,
        );
        setConfigMedidoresMap(new Map());
        setConfigRemarcadoresMap(new Map());
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fEmpresaId]);

  useEffect(() => {
    // 1) desde navigate state
    const st = location?.state || null;
    const idsFromState = Array.isArray(st?.newMedidorIds)
      ? st.newMedidorIds
      : [];
    const empresaFromState = st?.empresaId ?? null;
    const proveedorFromState = st?.proveedorId ?? null;

    // 2) fallback: sessionStorage (por refresh)
    let idsFromStorage = [];
    let empresaFromStorage = null;
    let proveedorFromStorage = null;

    try {
      const raw = sessionStorage.getItem("inventario_new_medidores");
      if (raw) {
        const parsed = JSON.parse(raw);
        idsFromStorage = Array.isArray(parsed?.ids) ? parsed.ids : [];
        empresaFromStorage = parsed?.empresaId ?? null;
        proveedorFromStorage = parsed?.proveedorId ?? null;
      }
    } catch {}

    const ids = (idsFromState.length ? idsFromState : idsFromStorage)
      .map((x) => Number(x))
      .filter((n) => Number.isFinite(n));

    if (ids.length > 0) {
      setNewIds(new Set(ids));

      // llevar a pestaña medidores
      setActiveIndex(0);

      // ayudarte a filtrar (opcional, pero recomendado)
      const emp = empresaFromState ?? empresaFromStorage;
      const prov = proveedorFromState ?? proveedorFromStorage;

      if (emp) setFEmpresaId(emp);
      if (prov) setFProveedorId(prov);

      // limpiar storage para no repetir el aviso siempre
      sessionStorage.removeItem("inventario_new_medidores");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (empresaIdFromQuery) {
      setEmpresaId(empresaIdFromQuery);
    }
    if (medidorIdFromQuery) {
      setMedidorId(medidorIdFromQuery);
    }
  }, [empresaIdFromQuery, medidorIdFromQuery]);

  const ubicacionDisplay = (row) =>
    [row?.ubicacion, row?.ubicacionDetalle]
      .map((x) => String(x ?? "").trim())
      .filter(Boolean)
      .join(" — ") || "-";

  const abrirCrear = () => {
    setModoDialog("crear");

    const baseForm = {
      id: null,
      codigo: "",
      numeroCliente: "",
      qrCode: null,
      idEmpresa: fEmpresaId ?? null,
      idProveedor: fProveedorId ?? null,
      idTipo: null,
      idUnidadMedida: null,
      marca: "",
      caracteristica: "",
      contrato: "",
      ruta: "",
      ubicacion: "",
      ubicacionDetalle: "",
      fechaInstalacion: null,
      lecturaInicial: null,
      activo: true,
    };

    if (fProveedorId) {
      const prov = proveedores?.find((p) => p?.id === fProveedorId);
      const tipoProvId = prov?.tipoProveedor?.id;
      const regla = AUTO_BY_TIPO_PROVEEDOR_ID?.[tipoProvId];

      if (regla) {
        baseForm.idTipo = getTipoIdByDesc(regla.tipo);
        baseForm.idUnidadMedida = getUnidadIdByDesc(regla.unidad);
      }
    }

    setForm(baseForm);
    setDialogVisible(true);
  };

  const parseLocalDateToDate = (s) => {
    if (!s || typeof s !== "string") return null;
    const [y, m, d] = s.split("-").map(Number);
    if (!y || !m || !d) return null;
    return new Date(y, m - 1, d);
  };

  const toLocalDateString = (date) => {
    if (!(date instanceof Date) || isNaN(date.getTime())) return null;
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const d = String(date.getDate()).padStart(2, "0");
    return `${y}-${m}-${d}`;
  };

  const abrirEditar = (row) => {
    setModoDialog("editar");
    setForm({
      id: row?.id ?? null,
      codigo: row?.codigo ?? "",
      numeroCliente: row?.numeroCliente ?? "",
      qrCode: row?.qrCode ?? null,
      idEmpresa: row?.empresa?.id ?? null,
      idProveedor: row?.proveedor?.id ?? null,
      idTipo: row?.tipo?.id ?? null,
      idUnidadMedida: row?.unidadMedida?.id ?? null,
      marca: row?.marca ?? "",
      caracteristica: row?.caracteristica ?? "",
      contrato: row?.contrato ?? "",
      ruta: row?.ruta ?? "",
      ubicacion: row?.ubicacion ?? "",
      ubicacionDetalle: row?.ubicacionDetalle ?? "",
      fechaInstalacion: parseLocalDateToDate(row?.fechaInstalacion),
      lecturaInicial: row?.lecturaInicial ?? null,
      activo: row?.activo ?? true,
    });
    setDialogVisible(true);
  };

  const abrirDetalleMedidor = async (medidor) => {
    setIsLoading(true);
    try {
      setMedidorSeleccionado(medidor);

      try {
        const data = await fetchJson(
          `${baseUrl}medidor/remarcadores?idMedidor=${encodeURIComponent(
            medidor.id,
          )}`,
          { method: "GET" },
        );

        const lista = Array.isArray(data.remarcadores) ? data.remarcadores : [];

        setRemarcadoresAsociados(lista);
        setCantidadRemarcadoresAsociados(
          Number.isFinite(Number(data?.cantidadRemarcadores))
            ? Number(data.cantidadRemarcadores)
            : lista.length,
        );
      } catch (e) {
        const msg = String(e.message || "").toUpperCase();
        if (msg.includes("NO TIENE REMARCAD") || msg.includes("NOT FOUND")) {
          setRemarcadoresAsociados([]);
          setCantidadRemarcadoresAsociados(0);
        } else {
          throw e;
        }
      }

      await cargarIncidencias(medidor.id);
      setDetalleMedidorVisible(true);
    } catch (e) {
      alert("Error cargando detalle del medidor: " + e.message);
    } finally {
      setIsLoading(false);
    }
  };

  const asignarRemarcador = async () => {
    if (!medidorSeleccionado || !nuevoRemarcadorId) return;

    setIsLoading(true);
    try {
      await fetchJson(`${baseUrl}medidor-remarcador/crear`, {
        method: "POST",
        body: JSON.stringify({
          idMedidor: medidorSeleccionado.id,
          idRemarcador: nuevoRemarcadorId,
        }),
      });

      // recargar
      await abrirDetalleMedidor(medidorSeleccionado);
      setNuevoRemarcadorId(null);
    } catch (e) {
      alert("Error asignando remarcador: " + e.message);
    } finally {
      setIsLoading(false);
    }
  };

  const quitarRemarcador = async (remarcador) => {
    confirmDialog({
      message: "¿Quitar este remarcador del medidor?",
      header: "Confirmar",
      icon: "pi pi-exclamation-triangle",
      accept: async () => {
        setIsLoading(true);
        try {
          await fetchJson(`${baseUrl}medidor-remarcador/eliminar`, {
            method: "PUT",
            body: JSON.stringify({
              idMedidor: medidorSeleccionado.id,
              idRemarcador: remarcador.id,
            }),
          });

          await abrirDetalleMedidor(medidorSeleccionado);
        } catch (e) {
          alert("Error quitando remarcador: " + e.message);
        } finally {
          setIsLoading(false);
        }
      },
    });
  };

  const validarFormulario = () => {
    if (
      !form.idEmpresa ||
      !form.idProveedor ||
      !form.idTipo ||
      !form.idUnidadMedida
    ) {
      alert(
        "Faltan campos obligatorios: Empresa, Proveedor, Tipo, Unidad de Medida.",
      );
      return false;
    }
    if (!validarNoCruceProveedorTipoUnidad()) return false;

    return true;
  };

  const guardar = async () => {
    if (!validarFormulario()) return;

    setIsLoading(true);
    try {
      const payload = {
        id: form.id,
        codigo: form.codigo?.trim() || null,
        numeroCliente: form.numeroCliente?.trim() || null,
        qrCode:
          form.qrCode !== null && form.qrCode !== ""
            ? Number(form.qrCode)
            : null,
        idEmpresa: form.idEmpresa,
        idProveedor: form.idProveedor,
        idTipo: form.idTipo,
        idUnidadMedida: form.idUnidadMedida,
        marca:
          form.marca && String(form.marca).trim().length > 0
            ? form.marca
            : "SIN DATOS",
        caracteristica:
          form.caracteristica && String(form.caracteristica).trim().length > 0
            ? form.caracteristica
            : "SIN DATOS",
        contrato: form.contrato?.trim() || null,
        ruta: form.ruta?.trim() || null,
        ubicacion: form.ubicacion?.trim() || null,
        ubicacionDetalle: form.ubicacionDetalle?.trim() || null,
        fechaInstalacion: toLocalDateString(form.fechaInstalacion),
        lecturaInicial:
          form.lecturaInicial !== null && form.lecturaInicial !== ""
            ? Number(form.lecturaInicial)
            : null,
        activo: form.activo,
      };

      if (modoDialog === "crear") {
        const url =
          categoriaActual === "MEDIDOR"
            ? `${baseUrl}medidor/insertar`
            : `${baseUrl}remarcador/insertar`;

        await fetchJson(url, {
          method: "POST",
          body: JSON.stringify(payload),
        });
      } else {
        // ✅ update único para ambos (medidor/remarcador)
        await fetchJson(`${baseUrl}medidor/actualizar`, {
          method: "PUT",
          body: JSON.stringify(payload),
        });
      }

      setDialogVisible(false);
      await cargarInventario();
    } catch (e) {
      alert("Error guardando: " + e.message);
    } finally {
      setIsLoading(false);
    }
  };

  const confirmarEliminar = async (row) => {
    const esRemarcador = row?.categoria?.toUpperCase?.() === "REMARCADOR";

    let cantidadRemarcadores = 0;

    if (!esRemarcador && row?.id) {
      try {
        const data = await fetchJson(
          `${baseUrl}medidor/remarcadores?idMedidor=${encodeURIComponent(
            row.id,
          )}`,
          { method: "GET" },
        );

        cantidadRemarcadores = Number.isFinite(
          Number(data?.cantidadRemarcadores),
        )
          ? Number(data.cantidadRemarcadores)
          : Array.isArray(data?.remarcadores)
          ? data.remarcadores.length
          : 0;
      } catch (e) {
        cantidadRemarcadores = 0;
      }
    }

    confirmDialog({
      message:
        !esRemarcador && cantidadRemarcadores > 0
          ? `¿Seguro que deseas desactivar este medidor? Tiene ${cantidadRemarcadores} remarcador(es) asociado(s) que deberán ser reubicados.`
          : `¿Seguro que deseas desactivar este ${
              esRemarcador ? "remarcador" : "medidor"
            }?`,
      header: "Confirmar",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Sí",
      rejectLabel: "No",
      accept: async () => {
        setIsLoading(true);
        try {
          const url = esRemarcador
            ? `${baseUrl}remarcador/eliminar?id=${row.id}`
            : `${baseUrl}medidor/eliminar?id=${row.id}`;

          await fetchJson(url, { method: "DELETE" });
          await cargarInventario();
        } catch (e) {
          alert("Error eliminando: " + e.message);
        } finally {
          setIsLoading(false);
        }
      },
    });
  };

  const confirmarActivar = (row) => {
    const esRemarcador = row?.categoria?.toUpperCase?.() === "REMARCADOR";

    confirmDialog({
      message: `¿Seguro que deseas activar este ${
        esRemarcador ? "remarcador" : "medidor"
      }?`,
      header: "Confirmar",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Sí",
      rejectLabel: "No",
      accept: async () => {
        setIsLoading(true);
        try {
          const url = esRemarcador
            ? `${baseUrl}remarcador/activar?id=${row.id}`
            : `${baseUrl}medidor/activar?id=${row.id}`;

          await fetchJson(url, { method: "PUT" });

          await cargarInventario();
        } catch (e) {
          alert("Error activando: " + e.message);
        } finally {
          setIsLoading(false);
        }
      },
    });
  };

  const abrirRelacionar = async (row) => {
    if (categoriaActual === "MEDIDOR") {
      setRelMedidorBase(row);
      setRelRemarcadorId(null);
      setRelDialogVisible(true);
      return;
    }

    setRelMedidorBase(null);
    setRelRemarcadorId(row?.id ?? null);
    setRelDialogVisible(true);
  };

  const medidoresOptions = useMemo(() => {
    return medidores
      .filter((m) => m?.activo === true || m?.activo === 1)
      .map((m) => ({
        label: `Medidor Código: ${m.codigo ?? "-"}`,
        value: m.id,
      }));
  }, [medidores]);

  const AUTO_BY_TIPO_PROVEEDOR_ID = {
    1: { tipo: "AGUA", unidad: "M**3" },
    2: { tipo: "ELECTRICIDAD", unidad: "KWH" },
  };

  const norm = (s) =>
    String(s ?? "")
      .trim()
      .toUpperCase()
      .replace(/\s+/g, " ");

  const getTipoIdByDesc = (desc) => {
    if (!desc || !Array.isArray(tipos)) return null;
    const d = norm(desc);
    const found = tipos.find((t) => norm(t?.descripcion) === d);
    return found?.id ?? null;
  };

  const getUnidadIdByDesc = (desc) => {
    if (!desc || !Array.isArray(unidadesMedida)) return null;
    const d = norm(desc);
    const found = unidadesMedida.find((u) => norm(u?.descripcion) === d);
    return found?.id ?? null;
  };

  const onProveedorChange = (proveedorId) => {
    const prov = proveedores?.find((p) => p?.id === proveedorId);
    const tipoProvId = prov?.tipoProveedor?.id;

    if (!proveedorId) {
      setForm((s) => ({
        ...s,
        idProveedor: null,
        idTipo: null,
        idUnidadMedida: null,
      }));
      return;
    }

    const regla = AUTO_BY_TIPO_PROVEEDOR_ID?.[tipoProvId];

    if (!regla) {
      setForm((s) => ({ ...s, idProveedor: proveedorId }));
      return;
    }

    const idTipoAuto = getTipoIdByDesc(regla.tipo);
    const idUnidadAuto = getUnidadIdByDesc(regla.unidad);

    setForm((s) => ({
      ...s,
      idProveedor: proveedorId,
      idTipo: idTipoAuto,
      idUnidadMedida: idUnidadAuto,
    }));
  };

  const EXPECTED_BY_TIPO_PROV = {
    1: { tipo: "AGUA", unidad: "M**3" },
    2: { tipo: "ELECTRICIDAD", unidad: "KWH" },
  };

  const getProveedorTipoId = (proveedorId) =>
    proveedores?.find((p) => p?.id === proveedorId)?.tipoProveedor?.id ?? null;

  const getTipoDescById = (tipoId) =>
    tipos?.find((t) => t?.id === tipoId)?.descripcion ?? null;

  const getUnidadDescById = (unidadId) =>
    unidadesMedida?.find((u) => u?.id === unidadId)?.descripcion ?? null;

  const validarNoCruceProveedorTipoUnidad = () => {
    if (!form.idProveedor || !form.idTipo || !form.idUnidadMedida) return true;

    const tipoProvId = getProveedorTipoId(form.idProveedor);
    const regla = EXPECTED_BY_TIPO_PROV?.[tipoProvId];
    if (!regla) return true; // si mañana hay tipo 3, no bloqueamos

    const tipoSel = norm(getTipoDescById(form.idTipo));
    const unidadSel = norm(getUnidadDescById(form.idUnidadMedida));

    const tipoOk = tipoSel === norm(regla.tipo);
    const unidadOk = unidadSel === norm(regla.unidad);

    if (!tipoOk || !unidadOk) {
      alert(
        `No puedes combinar datos.\n\n` +
          `Proveedor: ${norm(regla.tipo)}\n` +
          `Debe ser Tipo: ${regla.tipo} y Unidad: ${regla.unidad}.`,
      );
      return false;
    }

    return true;
  };

  const crearRelacion = async () => {
    const idMedidor =
      categoriaActual === "MEDIDOR" ? relMedidorBase?.id : relMedidorBase;
    const idRemarcador =
      categoriaActual === "MEDIDOR" ? relRemarcadorId : relRemarcadorId;

    const medidorIdFinal =
      categoriaActual === "MEDIDOR" ? relMedidorBase?.id : relMedidorBase;

    if (!medidorIdFinal || !idRemarcador) {
      alert("Debes seleccionar ambos: medidor y remarcador.");
      return;
    }

    setIsLoading(true);
    try {
      await fetchJson(`${baseUrl}medidor-remarcador/crear`, {
        method: "POST",
        body: JSON.stringify({
          idMedidor: medidorIdFinal,
          idRemarcador: idRemarcador,
        }),
      });

      setRelDialogVisible(false);
      await cargarInventario();
    } catch (e) {
      alert("Error creando relación: " + e.message);
    } finally {
      setIsLoading(false);
    }
  };

  const irAConfiguracionCorte = (row) => {
    const esRemarcador =
      String(row?.categoria || "").toUpperCase() === "REMARCADOR";

    let empresaId = row?.empresa?.id ?? null;
    let medidorId = row?.id ?? null;

    if (esRemarcador) {
      const remarcadorId = Number(row?.id);

      medidorId = remarcadorToMedidor.get(remarcadorId) ?? null;

      if (!medidorId) {
        const cfg = configRemarcadoresMap.get(remarcadorId);
        medidorId = cfg?.medidorPadreId ?? null;
      }

      if (!medidorId) {
        alert(
          "Este remarcador no tiene un medidor asociado. Debes relacionarlo primero.",
        );
        return;
      }

      if (!empresaId) {
        const medidorPadre = medidores.find(
          (m) => Number(m?.id) === Number(medidorId),
        );
        empresaId = medidorPadre?.empresa?.id ?? null;
      }
    }

    if (!empresaId) {
      alert("No se pudo determinar la empresa del medidor asociado.");
      return;
    }

    const params = new URLSearchParams();
    params.append("empresaId", empresaId);
    params.append("medidorId", medidorId);

    navigate(`/FechasCorte?${params.toString()}`);
  };

  const accionesBody = (rowData) => {
    const esRemarcador =
      String(rowData?.categoria || "").toUpperCase() === "REMARCADOR";
    const disableRelacionar =
      esRemarcador && isRemarcadorRelacionado(rowData?.id);

    return (
      <div style={{ display: "flex", gap: "0.5rem" }}>
        <Button
          icon="pi pi-pencil"
          className="p-button-rounded p-button-text"
          onClick={() => abrirEditar(rowData)}
          tooltip="Editar"
          tooltipOptions={{ position: "top" }}
        />

        <Button
          icon="pi pi-link"
          className="p-button-rounded p-button-text"
          onClick={() => abrirRelacionar(rowData)}
          tooltip={disableRelacionar ? "Ya está relacionado" : "Relacionar"}
          tooltipOptions={{ position: "top" }}
          disabled={disableRelacionar} // ✅ NUEVO
        />

        {isActivo(rowData) ? (
          <Button
            icon="pi pi-trash"
            className="p-button-rounded p-button-text p-button-danger"
            onClick={() => confirmarEliminar(rowData)}
            tooltip="Desactivar"
            tooltipOptions={{ position: "top" }}
          />
        ) : (
          <Button
            icon="pi pi-refresh"
            className="p-button-rounded p-button-text p-button-success"
            onClick={() => confirmarActivar(rowData)}
            tooltip="Activar"
            tooltipOptions={{ position: "top" }}
          />
        )}

        <Button
          icon="pi pi-camera"
          className="p-button-rounded p-button-text"
          onClick={() => abrirSubirFoto(rowData)}
          tooltip="Subir foto"
          tooltipOptions={{ position: "top" }}
        />
        <Button
          icon="pi pi-flag"
          className="p-button-rounded p-button-text p-button-warning"
          onClick={() => abrirReportarIncidencia(rowData)}
          tooltip="Reportar error"
          tooltipOptions={{ position: "top" }}
          disabled={isLoading}
        />

        <Button
          icon="pi pi-calendar"
          className="p-button-rounded p-button-text"
          tooltip="Configurar periodo de corte"
          tooltipOptions={{ position: "top" }}
          onClick={() => irAConfiguracionCorte(rowData)}
        />
      </div>
    );
  };

  const headerCard = (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "1rem",
        flexWrap: "wrap",
      }}
    >
      <div>
        <h4 style={{ margin: 0, color: "#495057" }}>Inventario</h4>
        <small style={{ color: "#6c757d" }}>
          Gestión de medidores y remarcadores
        </small>
      </div>

      <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
        {activeIndex === 0 && (
          <Button
            label="Cargar desde PDF"
            icon="pi pi-file-pdf"
            className="p-button-help"
            onClick={() => {
              setPdfMensaje(null);
              setPdfResultados([]);
              setPdfMedidoresVisible(true);
            }}
          />
        )}

        <Button
          label={tituloBotonAgregar}
          icon="pi pi-plus"
          onClick={abrirCrear}
        />
      </div>
    </div>
  );

  const tablaProps = {
    responsiveLayout: "scroll",
    className: "p-datatable-sm",
    paginator: true,
    rows: 10,
    rowsPerPageOptions: [5, 10, 20],
    stripedRows: true,
    sortMode: "multiple",
    showGridlines: true,
  };

  const cargarFotos = async (idMedidor) => {
    try {
      const data = await fetchJson(
        `${baseUrl}medidor/adjunto/listar?idMedidor=${encodeURIComponent(
          idMedidor,
        )}&tipo=FOTO`,
        { method: "GET" },
      );

      const list = Array.isArray(data?.adjuntos) ? data.adjuntos : [];
      setFotos(list);
      setActiveFotoIndex(0);
    } catch (e) {
      // Si falla, deja vacío
      setFotos([]);
      setActiveFotoIndex(0);
      const msg = String(e?.message || "");
      // no spamear alerts por "sin fotos"
      if (!msg.toUpperCase().includes("NO EXISTE")) {
        console.warn("No se pudieron cargar fotos:", msg);
      }
    }
  };

  const abrirSubirFoto = async (row) => {
    setItemFoto(row);
    setFotoFile(null);
    setFotoPreview(null);
    setFotos([]);
    setActiveFotoIndex(0);
    setFotoDialogVisible(true);
    resetFotoUploader();
    await cargarFotos(row.id);
  };

  const cerrarSubirFoto = () => {
    setFotoDialogVisible(false);
    setItemFoto(null);
    setFotoFile(null);
    setFotoPreview(null);
    resetFotoUploader();
  };

  const onSelectFoto = async (e) => {
    const file = e?.files?.[0];
    if (!file) return;

    if (!file.type?.startsWith("image/")) {
      alert("Solo se permiten imágenes.");
      resetFotoUploader();
      return;
    }

    const maxBytes = 5 * 1024 * 1024;
    if (file.size > maxBytes) {
      alert("Imagen muy grande. Máximo 5MB.");
      resetFotoUploader();
      return;
    }

    setFotoFile(file);

    const dataUrl = await fileToDataUrl(file);
    setFotoPreview(dataUrl);
  };

  const fileToDataUrl = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(String(reader.result || ""));
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });

  const ensureDataUrl = (base64OrDataUrl, mimeFallback = "image/jpeg") => {
    if (!base64OrDataUrl) return null;
    const s = String(base64OrDataUrl);

    // si ya viene como data:image/...;base64,xxx
    if (s.startsWith("data:")) return s;

    // si viene base64 "pelado"
    return `data:${mimeFallback};base64,${s}`;
  };

  const getMimeFromDataUrl = (dataUrl) => {
    // data:image/png;base64,....
    const m = String(dataUrl || "").match(/^data:([^;]+);base64,/i);
    return m?.[1] || null;
  };

  const subirFoto = async () => {
    if (!itemFoto?.id) {
      alert("No hay medidor/remarcador seleccionado.");
      return;
    }
    if (!fotoFile) {
      alert("Debes seleccionar una imagen.");
      return;
    }

    setIsLoading(true);
    try {
      const dataUrl = fotoPreview || (await fileToDataUrl(fotoFile));
      const mime = getMimeFromDataUrl(dataUrl) || fotoFile.type || "image/jpeg";
      const base64 = String(dataUrl).split("base64,")[1] || "";
      if (!base64) throw new Error("No se pudo leer el archivo en base64.");

      const payload = {
        idMedidor: itemFoto.id,
        tipoArchivo: "FOTO",
        archivo: base64,
      };

      const res = await fetch(`${baseUrl}medidor/adjunto/guardar`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await res.json().catch(() => ({}));
      if (!res.ok || data?.respuesta === false) {
        throw new Error(data?.mensaje || `Error HTTP ${res.status}`);
      }

      alert("Foto guardada correctamente.");

      await cargarFotos(itemFoto.id);
      setFotoFile(null);
      setFotoPreview(null);
      resetFotoUploader();

      await cargarInventario();
    } catch (e) {
      alert("Error subiendo foto: " + (e?.message || e));
    } finally {
      setIsLoading(false);
    }
  };

  const joinUrl = (base, path) =>
    `${String(base || "").replace(/\/+$/, "")}/${String(path || "").replace(
      /^\/+/,
      "",
    )}`;

  const buscarDirecciones = async (query) => {
    const q = String(query || "").trim();
    if (q.length < 3) {
      setUbicacionSug([]);
      return;
    }

    try {
      const url = joinUrl(
        urlContactos,
        `direcciones/buscar?q=${encodeURIComponent(q)}`,
      );

      // usamos fetchJson para respetar cookies/credenciales
      const data = await fetchJson(url, { method: "GET" });

      const dirs = Array.isArray(data?.direcciones)
        ? data.direcciones
            .map((x) => String(x?.direccion || "").trim())
            .filter(Boolean)
        : [];

      // quitamos duplicados por si acaso
      setUbicacionSug(Array.from(new Set(dirs)));
    } catch (e) {
      console.warn("No se pudieron cargar direcciones:", e?.message || e);
      setUbicacionSug([]);
    }
  };

  return (
    <div className="col-12 md:col-12">
      <ConfirmDialog />

      <div
        style={{
          padding: "20px",
          backgroundColor: "#f8f9fa",
          borderRadius: "8px",
          boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
          marginBottom: "20px",
        }}
      >
        {headerCard}
      </div>

      {/* Filtros */}
      <div
        style={{
          padding: "20px",
          backgroundColor: "#fff",
          borderRadius: "8px",
          boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.05)",
          marginBottom: "20px",
        }}
      >
        <div className="grid">
          <div className="col-12 md:col-3">
            <label style={{ fontWeight: "bold" }}>Empresa</label>
            <Dropdown
              value={fEmpresaId}
              options={[{ label: "Todas", value: null }, ...empresasOptions]}
              onChange={(e) => setFEmpresaId(e.value)}
              placeholder="Todas"
              style={{ width: "100%" }}
              showClear={false}
              disabled={isLoading}
            />
          </div>

          <div className="col-12 md:col-3">
            <label style={{ fontWeight: "bold" }}>Proveedor</label>
            <Dropdown
              value={fProveedorId}
              options={[{ label: "Todos", value: null }, ...proveedoresOptions]}
              onChange={(e) => setFProveedorId(e.value)}
              placeholder="Todos"
              style={{ width: "100%" }}
              filter
              showClear={false}
              disabled={isLoading}
            />
          </div>

          <div className="col-12 md:col-2">
            <label style={{ fontWeight: "bold" }}>Código</label>
            <InputText
              value={fCodigo}
              onChange={(e) => setFCodigo(e.target.value)}
              placeholder="Contiene..."
              style={{ width: "100%" }}
              disabled={isLoading}
            />
          </div>

          <div className="col-12 md:col-2">
            <label style={{ fontWeight: "bold" }}>N° Cliente</label>
            <InputText
              value={fNumeroCliente}
              onChange={(e) => setFNumeroCliente(e.target.value)}
              placeholder="Contiene..."
              style={{ width: "100%" }}
              disabled={isLoading}
            />
          </div>

          <div className="col-12 md:col-2">
            <label style={{ fontWeight: "bold" }}>Ruta</label>
            <InputText
              value={fRuta}
              onChange={(e) => setFRuta(e.target.value)}
              placeholder="Contiene..."
              style={{ width: "100%" }}
              disabled={isLoading}
            />
          </div>

          <div className="col-12 md:col-2">
            <label style={{ fontWeight: "bold" }}>Tipo</label>
            <Dropdown
              value={fTipoId}
              options={[{ label: "Todos", value: null }, ...tiposOptions]}
              onChange={(e) => setFTipoId(e.value)}
              placeholder="Todos"
              style={{ width: "100%" }}
              filter
              showClear={false}
              disabled={isLoading}
            />
          </div>

          <div className="col-12 md:col-2">
            <label style={{ fontWeight: "bold" }}>QR (exacto)</label>
            <InputText
              value={fQrExacto}
              onChange={(e) => setFQrExacto(e.target.value)}
              placeholder="Ej: 12345"
              style={{ width: "100%" }}
              disabled={isLoading}
            />
          </div>

          <div className="col-12 md:col-2">
            <label style={{ fontWeight: "bold" }}>Ubicación</label>
            <InputText
              value={fUbicacion}
              onChange={(e) => setFUbicacion(e.target.value)}
              placeholder="Contiene..."
              style={{ width: "100%" }}
              disabled={isLoading}
            />
          </div>

          <div className="col-12 md:col-2">
            <label style={{ fontWeight: "bold" }}>Estado</label>
            <Dropdown
              value={fActivo}
              options={activosOptions}
              onChange={(e) => setFActivo(e.value)}
              style={{ width: "100%" }}
              disabled={isLoading}
            />
          </div>

          <div className="col-12" style={{ marginTop: 10 }}>
            <Button
              label="Limpiar filtros"
              icon="pi pi-times"
              className="p-button-text"
              onClick={() => {
                setFEmpresaId(null);
                setFProveedorId(null);
                setFQrExacto("");
                setFUbicacion("");
                setFActivo("ACTIVOS");
                setFCodigo("");
                setFNumeroCliente("");
                setFRuta("");
                setFTipoId(null);
              }}
              disabled={isLoading}
            />
          </div>
        </div>
      </div>

      {isLoading && (
        <div style={{ textAlign: "center", margin: "20px 0" }}>
          <ProgressSpinner />
        </div>
      )}

      <div
        style={{
          padding: "20px",
          backgroundColor: "#fff",
          borderRadius: "8px",
          boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.05)",
          marginBottom: "20px",
        }}
      >
        <TabView
          activeIndex={activeIndex}
          onTabChange={(e) => setActiveIndex(e.index)}
        >
          <TabPanel header="Medidores">
            <DataTable
              value={medidoresFiltrados}
              dataKey="id"
              {...tablaProps}
              selectionMode="single"
              onRowClick={(e) => abrirDetalleMedidor(e.data)}
              rowClassName={(row) =>
                newIds.has(Number(row?.id)) ? "row-new-medidor" : ""
              }
            >
              <Column
                sortField="codigo"
                header="Código"
                body={(row) => row?.codigo ?? "-"}
                sortable
              />

              <Column
                field="numeroCliente"
                header="N° Cliente"
                sortable
                body={(row) => row?.numeroCliente ?? "-"}
              />

              <Column field="qrCode" header="QR" sortable />

              <Column
                header="Empresa"
                body={(row) => row?.empresa?.nombre ?? "-"}
                sortField="empresa.nombre"
                sortable
              />

              <Column
                header="Proveedor"
                sortField="proveedor.razonSocial"
                body={(row) => row?.proveedor?.razonSocial ?? "-"}
                sortable
              />

              <Column
                header="Tipo"
                body={(row) => row?.tipo?.descripcion ?? "-"}
                sortField="tipo.descripcion"
                sortable
              />

              <Column
                header="Unidad"
                body={(row) => row?.unidadMedida?.descripcion ?? "-"}
              />
              <Column field="contrato" header="Contrato" sortable />
              <Column field="ruta" header="Ruta" sortable />
              <Column field="marca" header="Marca" sortable />
              <Column field="caracteristica" header="Característica" />
              <Column header="Ubicación" body={ubicacionDisplay} sortable />
              <Column
                header="Fecha Instalación"
                body={(row) => formatDateCL(row?.fechaInstalacion) || "-"}
              />
              <Column field="lecturaInicial" header="Lectura Inicial" />

              <Column
                header="Activo"
                field="activo"
                body={(row) => (row.activo ? "Sí" : "No")}
                sortable
              />
              <Column
                header="Origen Config."
                body={(row) => {
                  const cfg = configMedidoresMap.get(Number(row?.id));
                  return origenLabel(cfg?.origenConfiguracion);
                }}
              />

              <Column
                header="Rango"
                body={(row) => {
                  const cfg = configMedidoresMap.get(Number(row?.id));
                  return rangoLabel(cfg?.diaDesde, cfg?.diaHasta);
                }}
              />

              <Column
                header="Política"
                body={(row) => {
                  const cfg = configMedidoresMap.get(Number(row?.id));
                  return politicaLabel(cfg?.politicaDiaHabil);
                }}
              />

              <Column
                header="Vigente desde"
                body={(row) => {
                  const cfg = configMedidoresMap.get(Number(row?.id));
                  return formatDateCL(cfg?.vigenteDesde) || "-";
                }}
              />

              <Column header="Acciones" body={accionesBody} />
            </DataTable>
          </TabPanel>

          <TabPanel header="Remarcadores">
            <DataTable
              value={remarcadoresFiltrados}
              dataKey="id"
              {...tablaProps}
            >
              <Column field="id" header="ID" sortable />

              <Column
                field="numeroCliente"
                header="N° Cliente"
                sortable
                body={(row) => row?.numeroCliente ?? "-"}
              />

              <Column field="qrCode" header="QR" sortable />

              <Column
                header="Empresa"
                body={(row) => row?.empresa?.nombre ?? "-"}
                sortField="empresa.nombre"
                sortable
              />

              <Column
                header="Proveedor"
                body={(row) => row?.proveedor?.razonSocial ?? "-"}
                sortField="proveedor.razonSocial"
                sortable
              />

              <Column
                header="Tipo"
                body={(row) => row?.tipo?.descripcion ?? "-"}
                sortField="tipo.descripcion"
                sortable
              />

              <Column
                header="Unidad"
                body={(row) => row?.unidadMedida?.descripcion ?? "-"}
              />

              <Column field="marca" header="Marca" sortable />
              <Column field="caracteristica" header="Característica" />
              <Column header="Ubicación" body={ubicacionDisplay} sortable />
              <Column
                header="Fecha Instalación"
                body={(row) => formatDateCL(row?.fechaInstalacion) || "-"}
              />
              <Column field="lecturaInicial" header="Lectura Inicial" />

              <Column
                header="Activo"
                body={(row) => (row.activo ? "Sí" : "No")}
                field="activo"
                sortable
              />

              <Column
                header="Medidor Padre"
                body={(row) => {
                  const cfg = configRemarcadoresMap.get(Number(row?.id));
                  return (
                    cfg?.medidorPadreCodigo ||
                    (cfg?.medidorPadreId ? `#${cfg.medidorPadreId}` : "-")
                  );
                }}
              />

              <Column
                header="Origen Config."
                body={(row) => {
                  const cfg = configRemarcadoresMap.get(Number(row?.id));
                  return origenLabel(cfg?.origenConfiguracion);
                }}
              />

              <Column
                header="Rango"
                body={(row) => {
                  const cfg = configRemarcadoresMap.get(Number(row?.id));
                  return rangoLabel(cfg?.diaDesde, cfg?.diaHasta);
                }}
              />

              <Column
                header="Política"
                body={(row) => {
                  const cfg = configRemarcadoresMap.get(Number(row?.id));
                  return politicaLabel(cfg?.politicaDiaHabil);
                }}
              />

              <Column
                header="Vigente desde"
                body={(row) => {
                  const cfg = configRemarcadoresMap.get(Number(row?.id));
                  return formatDateCL(cfg?.vigenteDesde) || "-";
                }}
              />

              <Column header="Acciones" body={accionesBody} />
            </DataTable>
          </TabPanel>
        </TabView>
      </div>

      {/* Dialog Agregar/Editar */}
      <Dialog
        header={
          modoDialog === "crear"
            ? tituloBotonAgregar
            : categoriaActual === "MEDIDOR"
            ? "Editar Medidor"
            : "Editar Remarcador"
        }
        visible={dialogVisible}
        style={{ width: "50vw" }}
        modal
        onHide={() => setDialogVisible(false)}
        footer={
          <div>
            <Button
              label="Cancelar"
              icon="pi pi-times"
              className="p-button-text"
              onClick={() => setDialogVisible(false)}
            />
            <Button label="Guardar" icon="pi pi-check" onClick={guardar} />
          </div>
        }
      >
        <div className="grid">
          <div className="col-12 md:col-6">
            <label style={{ fontWeight: "bold" }}>Código</label>
            <InputText
              value={form.codigo ?? ""}
              onChange={(e) =>
                setForm((s) => ({ ...s, codigo: e.target.value }))
              }
              style={{ width: "100%" }}
              placeholder="Ej: MED-001"
            />
          </div>

          <div className="col-12 md:col-6">
            <label style={{ fontWeight: "bold" }}>N° Cliente</label>
            <InputText
              value={form.numeroCliente ?? ""}
              onChange={(e) =>
                setForm((s) => ({ ...s, numeroCliente: e.target.value }))
              }
              style={{ width: "100%" }}
              placeholder="Ej: 12345678"
            />
          </div>
          <div className="col-12 md:col-6">
            <label style={{ fontWeight: "bold" }}>QR Code</label>
            <InputText
              value={form.qrCode ?? ""}
              onChange={(e) => {
                const soloNumeros = e.target.value.replace(/\D/g, "");
                setForm((s) => ({ ...s, qrCode: soloNumeros }));
              }}
              style={{ width: "100%" }}
              placeholder="Ej: 12345"
            />
          </div>

          <div className="col-12 md:col-6">
            <label style={{ fontWeight: "bold" }}>Empresa</label>
            <Dropdown
              value={form.idEmpresa}
              options={empresasOptions}
              onChange={(e) => setForm((s) => ({ ...s, idEmpresa: e.value }))}
              placeholder="Seleccione empresa"
              style={{ width: "100%" }}
              showClear
            />
          </div>

          <div className="col-12 md:col-6">
            <label style={{ fontWeight: "bold" }}>Proveedor</label>
            <Dropdown
              value={form.idProveedor}
              options={proveedoresOptions}
              onChange={(e) => onProveedorChange(e.value)}
              placeholder="Seleccione proveedor"
              style={{ width: "100%" }}
              filter
              showClear
            />
          </div>

          <div className="col-12 md:col-6">
            <label style={{ fontWeight: "bold" }}>Tipo</label>
            <Dropdown
              value={form.idTipo}
              options={tiposOptions}
              onChange={(e) => setForm((s) => ({ ...s, idTipo: e.value }))}
              placeholder="Seleccione tipo"
              style={{ width: "100%" }}
              filter
              showClear
              disabled={!!form.idProveedor}
            />
          </div>

          <div className="col-12 md:col-6">
            <label style={{ fontWeight: "bold" }}>Unidad de Medida</label>
            <Dropdown
              value={form.idUnidadMedida}
              options={unidadesOptions}
              onChange={(e) =>
                setForm((s) => ({ ...s, idUnidadMedida: e.value }))
              }
              placeholder="Seleccione unidad"
              style={{ width: "100%" }}
              filter
              showClear
              disabled={!!form.idProveedor}
            />
          </div>

          <div className="col-12 md:col-6">
            <label style={{ fontWeight: "bold" }}>Activo</label>
            <Dropdown
              value={form.activo}
              options={[
                { label: "Sí", value: true },
                { label: "No", value: false },
              ]}
              onChange={(e) => setForm((s) => ({ ...s, activo: e.value }))}
              style={{ width: "100%" }}
            />
          </div>

          <div className="col-12 md:col-6">
            <label style={{ fontWeight: "bold" }}>Marca</label>
            <InputText
              value={form.marca}
              onChange={(e) =>
                setForm((s) => ({ ...s, marca: e.target.value }))
              }
              style={{ width: "100%" }}
              placeholder="Marca"
            />
          </div>

          <div className="col-12 md:col-6">
            <label style={{ fontWeight: "bold" }}>Característica</label>
            <InputText
              value={form.caracteristica}
              onChange={(e) =>
                setForm((s) => ({ ...s, caracteristica: e.target.value }))
              }
              style={{ width: "100%" }}
              placeholder="Característica"
            />
          </div>

          <div className="col-12 md:col-6">
            <label style={{ fontWeight: "bold" }}>Contrato</label>
            <InputText
              value={form.contrato ?? ""}
              onChange={(e) =>
                setForm((s) => ({ ...s, contrato: e.target.value }))
              }
              style={{ width: "100%" }}
              placeholder="Ej: 12345678"
            />
          </div>

          <div className="col-12 md:col-6">
            <label style={{ fontWeight: "bold" }}>Ruta</label>
            <InputText
              value={form.ruta ?? ""}
              onChange={(e) => setForm((s) => ({ ...s, ruta: e.target.value }))}
              style={{ width: "100%" }}
              placeholder="Ej: R-102"
            />
          </div>

          <div className="col-12 md:col-6">
            <label style={{ fontWeight: "bold" }}>Ubicación</label>
            <AutoComplete
              value={form.ubicacion || ""}
              suggestions={ubicacionSug}
              completeMethod={(e) => buscarDirecciones(e.query)}
              dropdown
              forceSelection={false} // puedes dejar true si quieres obligar a seleccionar del listado
              placeholder="Escribe una dirección... (mín. 3 caracteres)"
              style={{ width: "100%" }}
              inputStyle={{ width: "100%" }}
              onChange={(e) => setForm((s) => ({ ...s, ubicacion: e.value }))}
              onSelect={(e) => setForm((s) => ({ ...s, ubicacion: e.value }))}
              disabled={isLoading}
            />
            <small style={{ color: "#6c757d" }}>
              Se guardará la dirección seleccionada (texto completo).
            </small>
          </div>

          <div className="col-12 md:col-6">
            <label style={{ fontWeight: "bold" }}>Detalle ubicación</label>
            <InputText
              value={form.ubicacionDetalle ?? ""}
              onChange={(e) =>
                setForm((s) => ({ ...s, ubicacionDetalle: e.target.value }))
              }
              style={{ width: "100%" }}
              placeholder="Ej: Casa 27, Depto 123, Bodega 15"
              disabled={isLoading}
            />
            <small style={{ color: "#6c757d" }}>
              Complemento manual (opcional) para la dirección.
            </small>
          </div>

          <div className="col-12 md:col-6">
            <label style={{ fontWeight: "bold" }}>Fecha instalación</label>
            <Calendar
              value={form.fechaInstalacion}
              onChange={(e) =>
                setForm((s) => ({ ...s, fechaInstalacion: e.value }))
              }
              style={{ width: "100%" }}
              dateFormat="dd-mm-yy"
              showIcon
              placeholder="DD-MM-YYYY"
            />
          </div>

          <div className="col-12">
            <label style={{ fontWeight: "bold" }}>Lectura Inicial</label>
            <InputText
              value={form.lecturaInicial ?? ""}
              onChange={(e) => {
                let value = e.target.value;
                value = value
                  .replace(/[^0-9.]/g, "")
                  .replace(/(\..*)\./g, "$1");

                setForm((s) => ({ ...s, lecturaInicial: value }));
              }}
              style={{ width: "100%" }}
              placeholder="0"
            />
          </div>
        </div>
      </Dialog>

      {/* Dialog Relacionar */}
      <Dialog
        header="Relacionar Medidor - Remarcador"
        visible={relDialogVisible}
        style={{ width: "40vw" }}
        modal
        onHide={() => setRelDialogVisible(false)}
        footer={
          <div>
            <Button
              label="Cancelar"
              icon="pi pi-times"
              className="p-button-text"
              onClick={() => setRelDialogVisible(false)}
            />
            <Button
              label="Relacionar"
              icon="pi pi-check"
              onClick={crearRelacion}
            />
          </div>
        }
      >
        <div className="grid">
          {categoriaActual === "MEDIDOR" ? (
            <>
              <div className="col-12">
                <label style={{ fontWeight: "bold" }}>Medidor</label>
                <InputText
                  value={
                    relMedidorBase
                      ? `Medidor Código: ${relMedidorBase.codigo ?? "-"}`
                      : ""
                  }
                  disabled
                  style={{ width: "100%" }}
                />
              </div>

              <div className="col-12">
                <label style={{ fontWeight: "bold" }}>Remarcador</label>
                {categoriaActual !== "MEDIDOR" &&
                  medidoresOptionsRelacion.length === 0 && (
                    <small style={{ color: "#dc3545" }}>
                      No hay medidores disponibles del mismo tipo que este
                      remarcador.
                    </small>
                  )}
                <Dropdown
                  value={relRemarcadorId}
                  options={remarcadoresOptionsRelacion}
                  onChange={(e) => setRelRemarcadorId(e.value)}
                  placeholder="Seleccione remarcador"
                  style={{ width: "100%" }}
                  filter
                  showClear
                />
              </div>
            </>
          ) : (
            <>
              <div className="col-12">
                <label style={{ fontWeight: "bold" }}>Remarcador</label>
                <InputText
                  value={
                    relRemarcadorId
                      ? `Remarcador QR: ${
                          remarcadores.find((r) => r?.id === relRemarcadorId)
                            ?.qrCode ?? "-"
                        }`
                      : ""
                  }
                  disabled
                  style={{ width: "100%" }}
                />
              </div>

              <div className="col-12">
                <label style={{ fontWeight: "bold" }}>Medidor</label>
                {categoriaActual === "MEDIDOR" &&
                  remarcadoresOptionsRelacion.length === 0 && (
                    <small style={{ color: "#dc3545" }}>
                      No hay remarcadores disponibles del mismo tipo que este
                      medidor.
                    </small>
                  )}
                <Dropdown
                  value={relMedidorBase}
                  options={medidoresOptionsRelacion}
                  onChange={(e) => setRelMedidorBase(e.value)}
                  placeholder="Seleccione medidor"
                  style={{ width: "100%" }}
                  filter
                  showClear
                />
              </div>
            </>
          )}
        </div>
      </Dialog>

      <Dialog
        header={`Remarcadores del Medidor #${medidorSeleccionado?.id ?? ""}`}
        visible={detalleMedidorVisible}
        style={{ width: "60vw" }}
        modal
        onHide={() => {
          setDetalleMedidorVisible(false);
          setNuevoRemarcadorId(null);
          setRemarcadoresAsociados([]);
          setCantidadRemarcadoresAsociados(0);
          setIncHistorial([]);
        }}
      >
        {/* Info básica */}
        <div style={{ marginBottom: "1rem" }}>
          <strong>QR:</strong> {medidorSeleccionado?.qrCode ?? "-"} <br />
          <strong>Empresa:</strong>{" "}
          {medidorSeleccionado?.empresa?.nombre ?? "-"} <br />
          <strong>Proveedor:</strong>{" "}
          {medidorSeleccionado?.proveedor?.razonSocial ?? "-"} <br />
          <strong>Remarcadores asociados:</strong>{" "}
          {cantidadRemarcadoresAsociados}
        </div>

        <div style={{ margin: "12px 0" }}>
          <div style={{ fontWeight: 700, marginBottom: 6 }}>Incidencias</div>

          {incHistorial.length === 0 ? (
            <div style={{ color: "#6c757d", fontSize: 13 }}>
              Sin incidencias.
            </div>
          ) : (
            <div style={{ display: "grid", gap: 8 }}>
              {incHistorial.map((x) => (
                <div
                  key={x.id}
                  style={{
                    border: "1px solid #eee",
                    borderRadius: 8,
                    padding: 10,
                    background: "#fafafa",
                  }}
                >
                  <div style={{ fontSize: 13 }}>
                    <strong>Reporte:</strong>{" "}
                    {formatDateCL(x.fechaReporte) || "-"}
                    {" · "}
                    <strong>Resolución:</strong>{" "}
                    {x.fechaResolucion
                      ? formatDateCL(x.fechaResolucion)
                      : "Pendiente"}
                  </div>
                  <div style={{ marginTop: 6 }}>{x.observacion}</div>

                  {!x.fechaResolucion && (
                    <div style={{ marginTop: 8 }}>
                      <Button
                        label="Marcar resuelta"
                        icon="pi pi-check"
                        className="p-button-sm p-button-text"
                        onClick={() =>
                          resolverIncidencia(x.id, medidorSeleccionado?.id)
                        }
                      />
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>

        {remarcadoresAsociados.length === 0 && (
          <div
            style={{
              padding: "0.75rem",
              background: "#f8f9fa",
              borderRadius: 6,
              marginBottom: "1rem",
            }}
          >
            Este medidor no tiene remarcadores asociados.
          </div>
        )}

        {/* Tabla remarcadores asociados */}
        <DataTable
          value={remarcadoresAsociados}
          dataKey="id"
          className="p-datatable-sm"
          stripedRows
        >
          <Column field="id" header="ID" />
          <Column field="qrCode" header="QR" />
          <Column field="marca" header="Marca" />
          <Column
            field="tipo.descripcion"
            header="Tipo"
            body={(r) => r?.tipo?.descripcion ?? "-"}
          />
          <Column header="Activo" body={(r) => (r.activo ? "Sí" : "No")} />
          <Column
            header="Acciones"
            body={(row) => (
              <Button
                icon="pi pi-times"
                className="p-button-rounded p-button-text p-button-danger"
                tooltip="Quitar remarcador"
                onClick={() => quitarRemarcador(row)}
              />
            )}
          />
        </DataTable>

        {/* Asignar nuevo */}
        <div className="grid" style={{ marginTop: "1.5rem" }}>
          <div className="col-12 md:col-8">
            <Dropdown
              value={nuevoRemarcadorId}
              options={remarcadoresOptionsAsignar}
              onChange={(e) => setNuevoRemarcadorId(e.value)}
              placeholder="Seleccionar remarcador a asignar"
              filter
              showClear
              style={{ width: "100%" }}
            />
          </div>
          <div className="col-12 md:col-4">
            <Button
              label="Asignar"
              icon="pi pi-plus"
              disabled={!nuevoRemarcadorId}
              onClick={asignarRemarcador}
            />
          </div>
        </div>
      </Dialog>

      <Dialog
        header={`Subir foto - ${itemFoto?.categoria ?? ""} #${
          itemFoto?.id ?? ""
        }`}
        visible={fotoDialogVisible}
        style={{ width: "40vw" }}
        modal
        onHide={cerrarSubirFoto}
        footer={
          <div>
            <Button
              label="Cancelar"
              icon="pi pi-times"
              className="p-button-text"
              onClick={cerrarSubirFoto}
            />
            <Button
              label="Subir"
              icon="pi pi-upload"
              onClick={subirFoto}
              disabled={!fotoFile}
            />
          </div>
        }
      >
        <div style={{ marginBottom: "1rem" }}>
          <div>
            <strong>ID:</strong> {itemFoto?.id ?? "-"}
          </div>
          <div>
            <strong>Categoría:</strong> {itemFoto?.categoria ?? "-"}
          </div>
          <div>
            <strong>QR:</strong> {itemFoto?.qrCode ?? "-"}
          </div>
        </div>

        <FileUpload
          key={fotoUploadKey}
          ref={fotoUploadRef}
          mode="basic"
          name="file"
          chooseLabel="Seleccionar imagen"
          accept="image/*"
          maxFileSize={5 * 1024 * 1024}
          customUpload
          auto={false}
          onSelect={onSelectFoto}
        />

        {(fotoPreview || fotos.length > 0) && (
          <div style={{ marginTop: "1rem" }}>
            <div style={{ fontWeight: "bold", marginBottom: 8 }}>
              {fotoPreview ? "Vista previa (nueva)" : "Fotos guardadas"}
            </div>

            {fotoPreview && (
              <img
                src={fotoPreview}
                alt="preview"
                style={{
                  maxWidth: "100%",
                  borderRadius: 8,
                  border: "1px solid #ddd",
                  marginBottom: 12,
                }}
              />
            )}

            {fotos.length > 0 && (
              <Galleria
                value={fotos}
                activeIndex={activeFotoIndex}
                onItemChange={(e) => setActiveFotoIndex(e.index)}
                numVisible={5}
                circular
                showItemNavigators
                showThumbnails
                item={(item) => (
                  <img
                    src={item?.archivo}
                    alt={`foto-${item?.id}`}
                    style={{
                      width: "100%",
                      display: "block",
                      borderRadius: 8,
                      border: "1px solid #ddd",
                    }}
                  />
                )}
                thumbnail={(item) => (
                  <img
                    src={item?.archivo}
                    alt={`thumb-${item?.id}`}
                    style={{ display: "block", width: "100%" }}
                  />
                )}
                style={{ maxWidth: "100%" }}
              />
            )}
          </div>
        )}

        {!fotoPreview && fotos.length === 0 && (
          <div
            style={{
              marginTop: "1rem",
              padding: "0.75rem",
              background: "#f8f9fa",
              borderRadius: 6,
            }}
          >
            Este medidor/remarcador aún no tiene fotos.
          </div>
        )}
      </Dialog>
      <Dialog
        header={`Reportar error - ${incItem?.categoria ?? ""} #${
          incItem?.id ?? ""
        }`}
        visible={incDialogVisible}
        style={{ width: "45vw" }}
        modal
        onHide={() => {
          setIncDialogVisible(false);
          setIncItem(null);
          setIncObservacion("");
          setIncHistorial([]);
        }}
        footer={
          <div>
            <Button
              label="Cerrar"
              icon="pi pi-times"
              className="p-button-text"
              onClick={() => setIncDialogVisible(false)}
            />
            <Button
              label="Reportar"
              icon="pi pi-flag"
              className="p-button-warning"
              onClick={reportarIncidencia}
              disabled={isLoading || tienePendiente}
            />
          </div>
        }
      >
        <div style={{ marginBottom: 12, color: "#6c757d", fontSize: 13 }}>
          Se guardará con fecha de reporte. Puedes marcarla resuelta más
          adelante.
        </div>

        {tienePendiente && (
          <div
            style={{
              marginBottom: 10,
              padding: 10,
              borderRadius: 8,
              background: "#fff3cd",
              color: "#664d03",
            }}
          >
            Ya existe una incidencia pendiente para este item. Debes marcarla
            como resuelta antes de reportar otra.
          </div>
        )}

        <div style={{ marginBottom: 10 }}>
          <label style={{ fontWeight: "bold" }}>Observación</label>
          <InputText
            value={incObservacion}
            onChange={(e) => setIncObservacion(e.target.value)}
            placeholder="Describe el problema..."
            style={{ width: "100%" }}
            disabled={isLoading || tienePendiente}
          />
        </div>

        <div style={{ marginTop: 12 }}>
          <div style={{ fontWeight: 700, marginBottom: 6 }}>Historial</div>

          {incHistorial.length === 0 ? (
            <div style={{ color: "#6c757d", fontSize: 13 }}>
              Sin incidencias.
            </div>
          ) : (
            <div style={{ display: "grid", gap: 8 }}>
              {incHistorial.map((x) => (
                <div
                  key={x.id}
                  style={{
                    border: "1px solid #eee",
                    borderRadius: 8,
                    padding: 10,
                    background: "#fafafa",
                  }}
                >
                  <div style={{ fontSize: 13 }}>
                    <strong>Reporte:</strong> {x.fechaReporte || "-"}
                    {" · "}
                    <strong>Resolución:</strong>{" "}
                    {x.fechaResolucion || "Pendiente"}
                  </div>
                  <div style={{ marginTop: 6 }}>{x.observacion}</div>

                  {!x.fechaResolucion && (
                    <div style={{ marginTop: 8 }}>
                      <Button
                        label="Marcar resuelta"
                        icon="pi pi-check"
                        className="p-button-sm p-button-text"
                        onClick={() => resolverIncidencia(x.id, incItem?.id)}
                      />
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </Dialog>

      <Dialog
        header="Cargar medidores desde boleta PDF"
        visible={pdfMedidoresVisible}
        style={{ width: "70vw", maxWidth: 1000 }}
        onHide={() => {
          setPdfMedidoresVisible(false);
          resetPdfFiles();
          setPdfResultados([]);
          setPdfMensaje(null);
        }}
      >
        <div className="grid">
          <div className="col-12 md:col-6">
            <label style={{ fontWeight: "bold" }}>Empresa</label>
            <Dropdown
              value={fEmpresaId}
              options={empresasOptions}
              onChange={(e) => setFEmpresaId(e.value)}
              placeholder="Seleccione empresa"
              style={{ width: "100%" }}
              showClear
              disabled={isLoading}
            />
          </div>

          <div className="col-12 md:col-6">
            <label style={{ fontWeight: "bold" }}>Proveedor</label>
            <Dropdown
              value={fProveedorId}
              options={proveedoresOptions}
              onChange={(e) => setFProveedorId(e.value)}
              placeholder="Seleccione proveedor"
              style={{ width: "100%" }}
              showClear
              disabled={isLoading}
            />
          </div>

          <div className="col-12">
            <label style={{ fontWeight: "bold" }}>PDF(s)</label>
            <div
              style={{
                display: "flex",
                gap: 10,
                alignItems: "center",
                flexWrap: "wrap",
              }}
            >
              <input
                id="pdf_medidores_input"
                type="file"
                accept="application/pdf,.pdf"
                multiple
                disabled={isLoading}
                onChange={onPickPdfMedidores}
                style={{
                  padding: "10px",
                  border: "1px solid #ced4da",
                  borderRadius: 6,
                  background: "#fff",
                }}
              />
              <div style={{ color: "#6c757d" }}>
                {pdfFiles?.length
                  ? `${pdfFiles.length} archivo(s) seleccionado(s)`
                  : "Sin archivos"}
              </div>
            </div>
          </div>

          {pdfMensaje && (
            <div className="col-12">
              <div
                style={{
                  padding: 10,
                  borderRadius: 6,
                  background:
                    pdfMensaje.severity === "error" ? "#f8d7da" : "#fff3cd",
                }}
              >
                {pdfMensaje.text}
              </div>
            </div>
          )}

          <div className="col-12">
            <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
              <Button
                label="Leer PDFs"
                icon="pi pi-upload"
                onClick={leerPdfMedidores}
                disabled={isLoading}
              />
              <Button
                label="Cargar medidores"
                icon="pi pi-check"
                className="p-button-success"
                onClick={confirmarPdfMedidores}
                disabled={isLoading || !pdfResultados?.length}
              />
              <Button
                label="Limpiar"
                icon="pi pi-times"
                className="p-button-text"
                onClick={() => {
                  resetPdfFiles();
                  setPdfResultados([]);
                  setPdfMensaje(null);
                }}
                disabled={isLoading}
              />
            </div>
          </div>

          {!!pdfResultados?.length && (
            <div className="col-12" style={{ marginTop: 10 }}>
              <DataTable
                value={pdfResultados}
                dataKey="_rowKey"
                {...tablaProps}
              >
                <Column field="nombre" header="Archivo" />
                <Column field="status" header="Estado" />
                <Column
                  header="Empresa detectada"
                  body={(row) => row?.empresaId ?? "-"}
                />
                <Column
                  header="Medidores detectados"
                  body={(row) => {
                    const items = getByPath(
                      row?.data,
                      "details.items_consumo",
                      [],
                    );
                    const codigos = Array.isArray(items)
                      ? Array.from(
                          new Set(
                            items
                              .map((x) => String(x?.medidor ?? "").trim())
                              .filter(Boolean),
                          ),
                        )
                      : [];
                    return codigos.length ? codigos.join(", ") : "—";
                  }}
                />
              </DataTable>
            </div>
          )}
        </div>
      </Dialog>
    </div>
  );
};

export default Inventario;
